"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustryToJSON = exports.IndustryFromJSONTyped = exports.IndustryFromJSON = exports.Industry = void 0;
/**
 *
 * @export
 */
exports.Industry = {
    Automotive: 'AUTOMOTIVE',
    Cpg: 'CPG',
    EducationTraining: 'EDUCATION_TRAINING',
    EnergyUtilities: 'ENERGY_UTILITIES',
    FinancialRealEstate: 'FINANCIAL_REAL_ESTATE',
    GovernmentNonProfit: 'GOVERNMENT_NON_PROFIT',
    MediaEntertainment: 'MEDIA_ENTERTAINMENT',
    MedicalPharmaceutical: 'MEDICAL_PHARMACEUTICAL',
    Political: 'POLITICAL',
    RestaurantsFoodService: 'RESTAURANTS_FOOD_SERVICE',
    RetailerWholesale: 'RETAILER_WHOLESALE',
    Technology: 'TECHNOLOGY',
    Telecommunications: 'TELECOMMUNICATIONS',
    TravelLeisure: 'TRAVEL_LEISURE',
    Other: 'OTHER'
};
function IndustryFromJSON(json) {
    return IndustryFromJSONTyped(json, false);
}
exports.IndustryFromJSON = IndustryFromJSON;
function IndustryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.IndustryFromJSONTyped = IndustryFromJSONTyped;
function IndustryToJSON(value) {
    return value;
}
exports.IndustryToJSON = IndustryToJSON;
